import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41.572 43.47"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"><path data-name=\"Path 7904\" d=\"M.75 7.377v13.254s0 6.627 15.463 6.627 15.463-6.627 15.463-6.627V7.377\"></path><path data-name=\"Path 7905\" d=\"M16.213.75c15.462 0 15.462 6.627 15.462 6.627s0 6.627-15.463 6.627S.75 7.377.75 7.377.75.75 16.213.75Z\"></path><path data-name=\"Path 7906\" d=\"M16.213 40.512C.75 40.512.75 33.885.75 33.885V20.631\"></path><path data-name=\"Path 7907\" d=\"M33.885 42.72V29.466m0 0 6.627 6.627m-6.627-6.627-6.627 6.627\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };